import { useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
const usePut = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [payload, setpayload] = useState(0);
    const navigate = useNavigate()
        const {tenant,token} = useParams();
    const putData = async (url, payload,action) => {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.put(url, payload,{
                headers:{
                    'Authorization': `Bearer ${token}` 
                }
            });
            setData(response.data);
            setLoading(false);
            setpayload(payload);
            // console.log('Post Request:',`URL:` ,url, `PAYLOAD:`,payload,`RESPONE:`,response.data);
            if(action){
                navigate(`/${tenant}/${action}`);
            }
        } catch (error) {
            setError(error);
            setLoading(false);
            // console.log(error);
            
        }
    };

    return { data, loading, error, putData,payload };
};

export default usePut;

